import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { TimetableFeature } from "../timetable/timetable.feature";

export const TimetableV2Feature: FeatureMetadata = {
  id: "timetable-v2",
  moduleName: "academics",
  guardianNavigation: {
    order: 6,
  },

  navigation: {
    label: "Timetable V2",
    path: "/timetable-v2",
    icon: CalendarDaysIcon,
    order: 6,
  },

  route: {
    path: "/timetable-v2",
    element: lazy(() => import("./pages/TimeTableV2Page")),
  },
  //  permissions: {
  //   view: "",
  //   create: "Academics.Timetable.create",
  //   edit: "Academics.Timetable.edit",
  //   delete: "Academics.Timetable.edit",
  // },

  // V2 shares the same permission set as V1 — same backend permissions apply.
  permissions: TimetableFeature.permissions,

  readiness: "live",
};
